export { default } from "./useCloneFunction";
